import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';

/** Work permit detail - common fields plus the named employer (standard lane). */
@Component({
    selector: 'app-work-detail',
    templateUrl: './work-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WorkDetailComponent {
    @Input() permit!: PermitDetail;
}
